import filteringHelper from './filteringHelper';

class PayloadHelper {
  buildBasePayloadProps(rootGetters, source) {
    // Get scan items
    const {
      query,
      query_elements,
      version_id,
      scan_id,
      user_id,
      name,
      description,
    } = rootGetters['scans/getScanDetails'];
    // Get scan type
    const scan_type = rootGetters['scans/scanType'];
    // Set filters to null by default
    let filters = null;
    // Set query_builder to query by default
    let query_builder = query;
    // Check if there is data in currentFiltering for the passed-in source --OR-- activeDataSource
    if (
      rootGetters['filters/currentFiltering'][source] &&
      Object.keys(rootGetters['filters/currentFiltering'][source]).length
    ) {
      // Current data source has applied filters, set them to filters var
      filters = Object.assign(
        {},
        rootGetters['filters/currentFiltering'][source]
      );

      // Process filters based on scan type
      if (scan_type !== 'semantic') {
        // Check if search_within_results is included in filters object
        if (filters.search_within_results) {
          // Call helper function to add search within results to query
          query_builder = filteringHelper.filterResultsText(
            query,
            filters.search_within_results
          );
        }
      } else {
        // Check if positive or negative filters are included in filters object
        if (filters.positive || filters.negative) {
          // Call helper function to add positive and negative filters to query
          query_builder = filteringHelper.filterSemantic(query_builder, {
            positive: filters.positive,
            negative: filters.negative,
          });
        }
      }
    }
    return {
      query_builder,
      filters,
      scan_type,
      scan_id,
      version_id,
      user_id,
      name,
      description,
      query_elements,
      query,
    };
  }
}

export default new PayloadHelper();
